import type { CSSProperties } from 'preact'

import { CookieIcon } from '#src/assets/ui/icons/CookieIcon.tsx'
import { uiTokens } from '#src/assets/ui/shared/styles.ts'

export function FloatingActionButton({
  visible,
  onClick,
}: {
  visible: boolean
  onClick: () => void
}) {
  return (
    <button
      type="button"
      aria-label="Cookie settings"
      style={{
        ...baseButtonStyle,
        opacity: visible ? '1' : '0',
        visibility: visible ? 'visible' : 'hidden',
        pointerEvents: visible ? 'auto' : 'none',
      }}
      onClick={event => {
        event.stopPropagation()
        onClick()
      }}
    >
      <CookieIcon />
    </button>
  )
}

const baseButtonStyle: CSSProperties = {
  position: 'fixed',
  bottom: '1rem',
  left: '1rem',
  width: '48px',
  height: '48px',
  color: uiTokens.colors.gray900,
  background: uiTokens.colors.gray50,
  border: `1px solid ${uiTokens.colors.gray200}`,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  zIndex: uiTokens.zIndex.max,
  transition: 'opacity 0.2s ease, visibility 0.2s ease, transform 0.2s ease',
}
